import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const Transport = ({ btn }) => {
  const transportInfo = (
    <>
      <p>
        The <strong>Transportation Services Platform</strong> allows users to rent vehicles and heavy equipment based on their needs. It's for <strong>Business-to-Consumer (B2C)</strong> connectivity.
      </p>
      <p>
        On this platform, users can rent <strong>LTVs (Light Transport Vehicles)</strong>, <strong>HTVs (Heavy Transport Vehicles)</strong>, and heavy equipment for personal or business use. This service operates as a <strong>B2C platform</strong>, where businesses offer rental services directly to consumers.
      </p>
      <p>
        The <strong>Transportation Services Platform</strong> provides <strong>flexible rental options, easy access, and convenience</strong>, helping users find the right transportation solution quickly and efficiently.
      </p>

           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Market</strong>
</a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + full transport info */}
          <CardNav Header="Transportation & Shipment" myid={1} myinfo={transportInfo} />

          {/* BoxData for Transport Service */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Transport Providers"
              Butonn={btn}
              imgg={images.TransportServices}
              url="/transport-integrate"
              link="/find-Transport"
              ms="twenty-element"
              buy="seventeen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Transport;
